<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <oxd-sheet :gutters="false" class="orangehrm-dashboard-widget ">
    <div class="orangehrm-dashboard-widget-header">
      <div class="orangehrm-dashboard-widget-name">
        <oxd-icon
          :name="icon"
          :type="iconType"
          class="orangehrm-dashboard-widget-icon"
        ></oxd-icon>
        <oxd-text tag="p">
          {{ title }}
        </oxd-text>
      </div>
      <slot name="action"></slot>
    </div>
    <oxd-divider />
    <oxd-loading-spinner
      v-if="loading"
      class="orangehrm-dashboard-widget-loader"
    />
    <div v-else ref="widgetRef" :class="widgetBodyClasses">
      <div
        v-if="total !== 0"
        style="display: flex; gap: 5px; margin-bottom: 5px; justify-content: space-between;"
      >
        <oxd-text
          tag="p"
          class="orangehrm-leave-card-emp-name orangehrm-text oxd-text--p"
        >
          Designação
        </oxd-text>
        <oxd-text
          tag="p"
          class="orangehrm-leave-card-emp-name orangehrm-text oxd-text--p"
        >
          Due date
        </oxd-text>
      </div>
      <div
        v-for="item in items?.data"
        :key="item.id"
        style="display: flex; gap: 5px; justify-content: space-between;"
      >
        <oxd-text
          tag="p"
          class="orangehrm-leave-card-leave-details orangehrm-text oxd-text--p"
        >
          {{ item.title }}
        </oxd-text>
        <oxd-text
          tag="p"
          class="orangehrm-leave-card-leave-details orangehrm-text oxd-text--p"
        >
          {{ item.due_date }}
        </oxd-text>
      </div>
      <slot></slot>
      <div
        v-if="total === 0 || empty"
        class="orangehrm-dashboard-widget-body-nocontent"
      >
        <img
          :src="defaultPic"
          alt="No Content"
          class="orangehrm-dashboard-widget-img"
        />
        <oxd-text tag="p">
          {{ emptyText || $t('dashboard.not_available') }}
        </oxd-text>
      </div>
    </div>
  </oxd-sheet>
</template>

<script>
import {computed, ref} from 'vue';
import Icon from '@ohrm/oxd/core/components/Icon/Icon';
import Sheet from '@ohrm/oxd/core/components/Sheet/Sheet';
import Spinner from '@ohrm/oxd/core/components/Loader/Spinner';
import {APIService} from '@/core/util/services/api.service';
import usePaginate from '@/core/util/composable/usePaginate';

export default {
  name: 'BaseWidget',
  components: {
    'oxd-sheet': Sheet,
    'oxd-icon': Icon,
    'oxd-loading-spinner': Spinner,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    empty: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: null,
    },
    iconType: {
      type: String,
      default: undefined,
    },
    query: {
      type: String,
    },
  },
  setup(props) {
    const widgetRef = ref();
    const defaultPic = `${window.appGlobal.baseUrl}/../images/dashboard_empty_widget_watermark.png`;

    const widgetBodyClasses = computed(() => ({
      'orangehrm-dashboard-widget-body': true,
      '--scroll-visible':
        widgetRef.value?.scrollHeight > widgetRef.value?.clientHeight,
    }));

    const employeeBackupAssignNormalizer = () => {
      return {
        hideClosed: true,
        limit: 5,
      };
    };

    const serializedFilters = computed(() => {
      return {hideClosed: true, limit: 5};
    });

    const http = new APIService(window.appGlobal.baseUrl, props.query);

    const {
      showPaginator,
      currentPage,
      total,
      pages,
      pageSize,
      response,
      isLoading,
      execQuery,
    } = usePaginate(http, {
      query: serializedFilters,
    });

    return {
      widgetRef,
      defaultPic,
      widgetBodyClasses,
      http,
      showPaginator,
      currentPage,
      isLoading,
      total,
      pages,
      pageSize,
      execQuery,
      items: response,
    };
  },
};
</script>

<style lang="scss" scoped>
@import 'base-widget.scss';
@import 'employee-on-leave-widget.scss';
.text-12 {
  font-size: 12px;
}
</style>
